const theme = {
  colors: {
    black: "#1E170A",
    cream: "#E6E1DA",
    rust: "#91897D",
    gold: "#D2CABE",
    aluminum: "#6B6358",
    white: "#ffffff",
  },
  fonts: {
    tacticRegular: "tactic-regular, sans-serif",
    tacticItalic: "tactic-italic, sans-serif",
    cartographBold: "cartograph-bold, sans-serif",
    cartographMedium: "cartograph-medium, sans-serif",
  },
}

export default theme
